import { observable } from 'mobx';

class TrafficMobx {
  @observable garden = './vr/garden/index.html';
}

export default TrafficMobx;